import appStore from 'store';
import api from './api';
import {NEWS_HOT_TYPE} from './constants';
import LANGUAGE from 'common/languages_code';

const store = {
    namespaced: true,
    state: {
        newsList: [],
        opType:'',
        detailDialogVisible: false,
        query: {language: String(Object.keys(LANGUAGE)[0])},
        newsDetail: {hot:false},
        newsHotList: NEWS_HOT_TYPE.slice(),
        languageList: Object.keys(LANGUAGE).map(item => {
            return {
                value: String(item),
                label: LANGUAGE[item]
            };
        })
    },
    getters: {
        newsList: state =>
            state.newsList
                .map(item => {
                    return {
                        ...item,
                        _hotType: NEWS_HOT_TYPE.filter((v, i, a) => {
                            return v.value == item.hot;
                        })[0].label
                    };
                }),
        newsDetail: state => state.newsDetail
    },
    mutations: {
        setNewsList(state, payload) {
            state.newsList = payload.slice();
        },
        toggleDetailDialogVisible(state, payload) {
            state.detailDialogVisible = payload;
        },
        setNewsDetail(state, payload) {
            state.newsDetail = Object.assign({}, payload);
        },
        changeQuery(state, payload) {
            state.query = payload;
        },
        setOpType(state,payload) {
            state.opType = payload;
        }
    },
    actions: {
        list({commit}, query) {
            api.getNewsList(query).then(({data}) => {
                commit('setNewsList', data.data);
            });
        },
        setDetail({commit}, data) {
            commit('setNewsDetail', data);
        },
        create({commit}, news) { // eslint-disable-line
            console.log('111111111');
            return new Promise(resolve => {
                api.createNews(news).then(res => {
                    resolve(res);
                });
            });
        },
        update({commit}, {createTime, ...news}) { // eslint-disable-line
            return new Promise(resolve => {
                api.updateNews(news).then(res => {
                    resolve(res);
                });
            });
        },
        remove({commit}, id) { // eslint-disable-line
            return new Promise(resolve => {
                api.removeNews(id).then(res => {
                    resolve(res);
                });
            });
        },
        buildOpType({commit},val) {
            commit('setOpType',val);
        }
    }
};

appStore.registerModule('newsSetting', store);
